import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { cn } from '../utils/cn';

const EducationalSection = () => {
  return (
    <section className="mt-12 sm:mt-20 border-t border-slate-200 dark:border-slate-800 pt-12 sm:pt-16 px-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12 text-left">
        {[
          {
            icon: FiIcons.FiCpu,
            title: "AI Semantic Clustering",
            desc: "Our engine uses Natural Language Processing to group keywords by meaning, not just letters. Build high-authority Content Hubs.",
            color: "bg-blue-100 dark:bg-blue-900/30 text-blue-600"
          },
          {
            icon: FiIcons.FiMapPin,
            title: "Geo-SEO Intelligence",
            desc: "Optimize for hyper-local search. Detect regional patterns and adjust your strategy for specific markets and dialects.",
            color: "bg-emerald-100 dark:bg-emerald-900/30 text-emerald-600"
          },
          {
            icon: FiIcons.FiZap,
            title: "Intent-Driven ROI",
            desc: "Stop chasing vanity metrics. We prioritize commercial and transactional intent keywords that directly impact your bottom line.",
            color: "bg-amber-100 dark:bg-amber-900/30 text-amber-600"
          }
        ].map((item, i) => (
          <div key={i} className="space-y-4 group">
            <div className={cn("w-12 h-12 rounded-2xl flex items-center justify-center transition-transform group-hover:scale-110 duration-300", item.color)}>
              <SafeIcon icon={item.icon} className="w-6 h-6" />
            </div>
            <h3 className="text-lg sm:text-xl font-black text-slate-900 dark:text-white">{item.title}</h3>
            <p className="text-slate-500 dark:text-slate-400 text-sm leading-relaxed">
              {item.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default EducationalSection;